module.exports = __webpack_public_path__ + "img/projects1-wide.3baa5d3a.png";